import './HeaderTabsContainer.less';

import React, { useContext } from 'react';
import clsx from 'clsx';
import { fireGAEvent } from '@/analytics';
import i18n from '@i18n';
import { trackingDataForMarketStatisticsEvent } from 'nike-ui/src/components/market-statistics/view/MarketStatisticsDetail';
import SportEventContext from 'nike-ui/src/common/SportEventContext';
import RouteLink from 'nike-ui/src/common/routing/RouteLink';

function HeaderTabsContainer({ children, className, ...other }) {
    const sportEvent = useContext(SportEventContext);
    return (
        <div
            className={clsx('page-header-tabs', className)}
            {...trackingDataForMarketStatisticsEvent(sportEvent)}
            {...other}
        >
            {children}
        </div>
    );
}

export function TabButton({
    activeCheck,
    activeRoute,
    badgeCount = null,
    badgeMsg,
    children,
    icon: Icon,
    i18nCode,
    onTabChange,
    route,
    params,
    scrollElementRef,
    trackData,
    'data-atid': dataAtid,
    'data-tab-name': dataTabName = 'Unknown tab'
}) {
    const codes = activeCheck && typeof activeCheck !== 'boolean' ? activeCheck.concat([route]) : [route];

    function beforeNavigate() {
        if (trackData) {
            fireGAEvent(trackData.category, trackData.action, trackData.label);
        }
        if (onTabChange) {
            onTabChange(route);
            return false;
        }
        return true;
    }

    return (
        <RouteLink
            route={route}
            params={params}
            beforeNavigate={beforeNavigate}
            ref={route === activeRoute ? scrollElementRef : null}
            data-atid={dataAtid || 'main-menu-' + route.name}
            data-tab-name={dataTabName}
            className={clsx('tab-button', {
                active: typeof activeCheck === 'boolean' ? activeCheck : codes.includes(activeRoute)
            })}
        >
            <div
                className={clsx('tab-button-content', {
                    'item-badge': badgeCount,
                    'item-badge-msg': badgeMsg
                })}
                data-badge={badgeCount || badgeMsg}
            >
                {Icon && <Icon />}
                {i18nCode ? <span>{i18n(i18nCode)}</span> : children ? <span>{children}</span> : null}
            </div>
            <div className="tab-button-border-vertical" />
            <div className="tab-button-border-horizontal" />
        </RouteLink>
    );
}

export default HeaderTabsContainer;
